import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AdminPage from './pages/AdminPage/AdminPage';
import Events from './pages/Events/Events';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import Products from './pages/Products/Products';
import AboutUs from './pages/AboutUs/AboutUs';
import Contact from './pages/Contact/Contact';
import { getAuth } from 'firebase/auth'; 

// ruta privata, da redirect inapoi de la admin la login daca nu e logat
const PrivateRoute = () => {
  const user = getAuth().currentUser;
  return user ? <AdminPage /> : <Navigate to="/login" />; // daca admn nu e logat, redirectioneaza inapoi
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/products" element={<Products />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<PrivateRoute />} />  // Protejează ruta de admin
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
      </Routes>
    </Router>
  );
}

export default App;
